<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import { id } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import PaginationCustom from '@/components/table/Pagination.vue'
import PbgDetail from '@/components/simbg/PbgDetail.vue'
import kodeDaerah from '@/data/modules/kodeDaerah'
import fungsiBangunan from '@/data/modules/fungsiBangunan'
import jenisPermohonanSimbg from '@/data/modules/jenisPermohonanSimbg'

export default {
   name: 'SimbgPbg',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      PbgDetail,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         filterDateLang: id,
         options: {
            klasifikasi: [
               { value: null, text: '-' },
               { value: 1, text: 'Sederhana' },
               { value: 2, text: 'Tidak Sederhana' },
            ],
            fungsi: [
               { value: null, text: '-' },
               ...fungsiBangunan.map(item => ({ value: item, text: item })),
            ],
         },
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               tanggal_awal: null,
               tanggal_akhir: null,
               building_type: null,
               function_type: null,
               application_type: null,
               daerah_id: null,
               daerah_mode: 'kecamatan',
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [
            {
               label: 'No Dokumen',
               field: 'no_izin',
               sortable: false,
               thClass: 'text-center align-middle',
            },

            {
               label: 'Jenis Permohonan',
               field: 'nm_konsultasi',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Pemilik',
               field: 'nm_pemilik',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Lokasi Bangunan',
               field: 'almt_bgn',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         myData: state => state.Simbgv2024.items,
         myProses: state => state.Simbgv2024.itemsProses,
         myCount: state => state.Simbgv2024.countAll,
      }),
      tanggalPenetapan() {
         return tanggal => {
            let value = ''

            if (tanggal !== '0000-00-00') {
               value = this.$moment(tanggal).format('DD MMMM YYYY')
            } else {
               value = '-'
            }

            return value
         }
      },
      optionsDaerah() {
         return kodeDaerah.map(item => ({
            value: item.kode,
            text: `${item.kode} - ${item.kecamatan} - ${item.kelurahan}`,
         }))
      },
      optionsJenisPermohonan() {
         return jenisPermohonanSimbg.map(item => ({
            value: item.id,
            text: item.name,
         }))
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'Simbgv2024/getData',
         getDataProses: 'Simbgv2024/getProses',
         cetakPbg: 'Simbgv2024/cetakPbg',
         cetakSlf: 'Simbgv2024/cetakSlf',
         cetakPermohonan: 'Simbgv2024/cetakPermohonan',
      }),
      ...mapMutations({
         setIdIzin: 'Simbgv2024/SET_ID_IZIN',
      }),
      onDetailIzin(idIzin) {
         this.setIdIzin(idIzin)
         this.$bvModal.show('modal-detail')
      },
      onCetakPbg(uid) {
         this.loadingPdf = true
         this.cetakPbg(uid).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetakSlf(uid) {
         this.loadingPdf = true
         this.cetakSlf(uid).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.serverParams.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.serverParams.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.serverParams.filter.building_type !== null) {
            params.building_type = this.serverParams.filter.building_type
         }
         if (this.serverParams.filter.function_type !== null) {
            params.function_type = this.serverParams.filter.function_type
         }
         if (this.serverParams.filter.application_type !== null) {
            params.application_type = this.serverParams.filter.application_type
         }
         if (this.serverParams.filter.daerah_id !== null) {
            params.daerah_id = this.serverParams.filter.daerah_id
            params.daerah_mode = this.serverParams.filter.daerah_mode
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakPermohonan(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },

      // VUE GOOD TABLE
      loadItems() {
         this.loading = true
         this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.serverParams.filter.tanggal_akhir = new Date()
         this.serverParams.filter.building_type = null
         this.serverParams.filter.function_type = null
         this.serverParams.filter.application_type = null
         this.serverParams.filter.daerah_id = null
         this.serverParams.filter.daerah_mode = 'kecamatan'
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = null
         this.serverParams.filter.tanggal_akhir = null
         this.serverParams.filter.building_type = null
         this.serverParams.filter.function_type = null
         this.serverParams.filter.application_type = null
         this.serverParams.filter.daerah_id = null
         this.serverParams.filter.daerah_mode = 'kecamatan'
         this.loadItems()
      },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data PBG">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button
                        v-b-tooltip.hover.top="'Filter'"
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col cols="12">
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="3">
                           <b-form-group label="Tanggal Terbit Awal" label-for="tanggal-awal">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_awal"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Tanggal Terbit Akhir" label-for="tanggal-akhir">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_akhir"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Klasifikasi" label-for="klasifikasi">
                              <v-select
                                 id="klasifikasi"
                                 v-model="serverParams.filter.building_type"
                                 :options="options.klasifikasi"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Klasifikasi..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Fungsi" label-for="fungsi">
                              <v-select
                                 id="fungsi"
                                 v-model="serverParams.filter.function_type"
                                 :options="options.fungsi"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Fungsi..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="6">
                           <b-form-group label="Jenis Permohonan" label-for="jenis-permohonan">
                              <v-select
                                 id="jenis-permohonan"
                                 v-model="serverParams.filter.application_type"
                                 :options="optionsJenisPermohonan"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis Permohonan..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="6">
                           <b-form-group label="Daerah" label-for="daerah">
                              <b-form-radio-group
                                 id="daerah-mode"
                                 v-model="serverParams.filter.daerah_mode"
                                 :options="[{ text: 'Kecamatan', value: 'kecamatan' }, { text: 'Kelurahan/Desa', value: 'kelurahan' }]"
                                 class="mb-1"
                                 @change="serverParams.filter.daerah_id = null; onFilter()"
                              />
                              <v-select
                                 id="daerah"
                                 v-model="serverParams.filter.daerah_id"
                                 :options="optionsDaerah"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Daerah..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->

         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'no_izin'">
                  <b>{{ (props.row.document_number) }}</b>
                  <hr>
                  <small>Nama : {{ props.row.application_type_name }}</small>
                  <hr>
                  <small>Terbit : {{ props.row.tgl_terbit | moment("DD-MM-YYYY") }}</small>
               </span>

               <span v-if="props.column.field == 'nm_pemilik'">
                  <b>{{ props.row.owner_name }}</b>
               </span>

               <span v-if="props.column.field == 'nm_konsultasi'">
                  {{ (props.row.consultation_type) }}
                  <hr>
                  <small>Fungsi : {{ props.row.function_type }}</small>
                  <hr>
                  <small>Klasifikasi : {{ props.row.building_type_name }}</small>
               </span>

               <span v-else-if="props.column.field == 'almt_bgn'">
                  {{ (props.row.building_address) }}
                  <hr>
                  <small>Kecamatan : {{ (props.row.building_district_name) }}</small>
               </span>

               <span v-else-if="props.column.field == 'tgl_ditetapkan'">{{ tanggalPenetapan(props.row.tgl_terbit)
               }}</span>

               <span v-if="props.column.field == 'action'">
                  <b-button
                     v-if="props.row.s3_path"
                     size="sm"
                     block
                     variant="outline-dark"
                     class="nowrap"
                     @click="onDetailIzin(props.row.id_izin)"
                  >
                     <feather-icon icon="EyeIcon" class="mr-50" />
                     <small>Detail</small>
                  </b-button>
                  <b-button
                     v-if="props.row.pbg_s3_path"
                     size="sm"
                     block
                     variant="primary"
                     class="nowrap"
                     @click="onCetakPbg(props.row.uid)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>PBG</small>
                  </b-button>
                  <b-button
                     v-if="props.row.slf_s3_path"
                     size="sm"
                     block
                     variant="primary"
                     class="nowrap"
                     @click="onCetakSlf(props.row.uid)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>SLF</small>
                  </b-button>
               </span>
               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-detail"
         scrollable
         size="lg"
         centered
         hide-footer
         title="Izin Detail"
      >
         <PbgDetail />
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless>tr>td {
   border: none;
   padding: 0em;
}

.borderless>tr>td {
   border: none;
   padding: 0em;
}

table>tbody>tr>td>span>hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.hidden_header {
   display: none;
}
</style>
